export var ChainGrowingContent;
(function (ChainGrowingContent) {
    ChainGrowingContent["Slack"] = "slack";
    ChainGrowingContent["Tight"] = "tight";
    ChainGrowingContent["ComingTight"] = "coming tight";
    ChainGrowingContent["ShortStay"] = "short stay";
    ChainGrowingContent["MediumStay"] = "medium stay";
    ChainGrowingContent["LongStay"] = "long stay";
})(ChainGrowingContent || (ChainGrowingContent = {}));
//# sourceMappingURL=ChainGrowingContent.js.map